export enum NUDGES_TYPE {
    JoinRewardProgramTemplate = "JOIN_REWARD_PROGRAM",
    PointsSpendingTemplate = "POINT_SPENDING",
    RewardAvailableTemplate = "REWARD_AVAILABLE",
}

export enum CTAW_TYPE {
    BUTTON_LINK = "BUTTON_LINK",
    LOGIN_OR_SIGN_UP = "LOGIN_OR_SIGN_UP",
    BUTTON_REDEEM_REWARD = "BUTTON_REDEEM_REWARD",
    BUTTON_APPLY_DISCOUNT = "BUTTON_APPLY_DISCOUNT",
}

export interface SelectedDiscountValue {
    itemId: number;
    type: NUDGES_REWARD_TYPE;
    code: string;
    variantId?: number;
}

export enum NUDGES_REWARD_TYPES {
    points = "points",
    discount = "discount",
    giftCard = "gift_card",
    freeProduct = "free_product",
}

type NUDGES_REWARD_TYPE = `${NUDGES_REWARD_TYPES}`;
